import {
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAILED,
} from './actionTypes';

export const getRolesRequest = () => ({ type: GET_ROLES_REQUEST });
export const getRolesSuccess = (roles) => ({
  type: GET_ROLES_SUCCESS, roles,
});
export const getRolesFailure = (error) => ({ type: GET_ROLES_FAILED, error });
